import { produce } from 'immer';
import type { SingleValueFilter } from '@/scopes/checkout/filterableCars/domain/types';

interface SingleValueFilterPayload {
  value: string;
}

export function updateSingleValueFilter(payload: SingleValueFilterPayload) {
  return produce((filter: SingleValueFilter) => {
    filter.selectedFilter = payload.value;
  });
}
